import { stdObject } from "../../../data/types/stdObject";
import { getPrefix } from "../../../utils/getPrefix";

export const createTable = ({ headerData, data, t }: stdObject) => {
  const table = document.createElement("table");
  table.style.borderSpacing = "0px";
  table.style.width = data.TANDOC + "px";
  table.style.fontSize = data.SIZDOC + "px";

  const thead = document.createElement("thead");
  const trHead = document.createElement("tr");

  headerData.forEach((e: stdObject) => {
    const th = document.createElement("th");
    if (e.ANCPAR > 0) {
      th.style.width = e.ANCPAR + "px";
    }
    th.style.padding = data.PADDOC + "px";
    th.style.fontSize = data.SIZDOC + "px";
    th.textContent = t(`c.${getPrefix(e.PARPAR)}`);
    trHead.appendChild(th);
  });

  thead.appendChild(trHead);

  const tbody = document.createElement("tbody");

  table.appendChild(thead);
  table.appendChild(tbody);

  return table;
};
